import { render, staticRenderFns } from "./radu_editor.vue?vue&type=template&id=589cb2cc&scoped=true&"
import script from "./radu_editor.vue?vue&type=script&lang=js&"
export * from "./radu_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589cb2cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('589cb2cc')) {
      api.createRecord('589cb2cc', component.options)
    } else {
      api.reload('589cb2cc', component.options)
    }
    module.hot.accept("./radu_editor.vue?vue&type=template&id=589cb2cc&scoped=true&", function () {
      api.rerender('589cb2cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/radu/radu_editor.vue"
export default component.exports